import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";
import Popover, { PopoverProps } from "@mui/material/Popover";
import { useTheme } from "@mui/material/styles";
import { propsWithSx } from "designSystem/styles/style-functions";
import React, { FunctionComponent } from "react";
import IconButton from "../button/IconButton";
import { blue } from "designSystem/styles/color";
import Grid from "../grid/Grid";
import Text from "../text/Text";

const paperStyles = (theme) => {
	return {
		backgroundColor: blue[50],
		maxWidth: 410,
		padding: theme.spacing(4),
	};
};

export interface InfoPopoverProps extends Omit<PopoverProps, "onClose"> {
	/** event handler called by when popover closes */
	onClose: () => void;

	/** localization resource for info text */
	res?: string;

	/** parameters for localization resource for info message */
	resParams?: Array<number | string>;
}

export const InfoPopover: FunctionComponent<InfoPopoverProps> = (props) => {
	const { children, onClose, res, resParams, PaperProps, ...otherProps } = props;
	const theme = useTheme();

	return (
		<Popover
			PaperProps={propsWithSx(PaperProps, paperStyles(theme))}
			onClose={onClose}
			{...otherProps}
		>
			{children ?
				children
				: (
					<Grid
						container
						spacing={3}
						wrap="nowrap"
					>
						<Grid item>
							<InfoIcon color="primary" fontSize="large" />
						</Grid>
						<Grid item>
							<Text res={res} resParams={resParams} />
						</Grid>
						<Grid item>
							<IconButton
								design="defaultOnGrey"
								onClick={onClose}
								round
								size="small"
							>
								<CloseIcon />
							</IconButton>
						</Grid>
					</Grid>
				)}
		</Popover>
	);
};

export default InfoPopover;